import { render, staticRenderFns } from "./SimpleCardIcon.vue?vue&type=template&id=7b04f63e&"
import script from "./SimpleCardIcon.vue?vue&type=script&lang=ts&"
export * from "./SimpleCardIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports